angular.module('impactx.search').controller('CatalogItemActionCtrl', [
    'TranslationService',
    '$redirect',
    'ThemeWorldService',
    'panelService',
    '$context',
    'ProductViewService',
    CatalogItemActionCtrl]);

function CatalogItemActionCtrl(TranslationService, $redirect, ThemeWorldService, panelService, $context, ProductViewService) {
    var self = this;

    self.trns = {
        addToThemeWorld: TranslationService.get('addToThemeWorld'),
        removeFromThemeWorld: TranslationService.get('removeFromThemeWorld'),
        addToProductView: TranslationService.get('addToProductView'),
        removeFromProductView: TranslationService.get('removeFromProductView')
    };

    self.$onInit = function () {
        self.hasActions = self.catalog.canAddToThemeWorld || self.catalog.canAddToProductView || self.catalog.canRemoveFromThemeWorld || self.catalog.canRemoveFromProductView;
    };

    self.addToThemeWorld = function($event) {
        self.catalog.canAddToThemeWorld = false;
        self.catalog.canRemoveFromThemeWorld = true;
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        ThemeWorldService.addVCatsToThemeWorld([self.catalog]);
    };

    self.removeFromThemeWorld = function($event) {
        var catalogIds = [];
        self.catalog.canAddToThemeWorld = true;
        self.catalog.canRemoveFromThemeWorld = false;
        catalogIds.push(self.catalog.id);
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        ThemeWorldService.removeVCatsFromThemeWorld($context.hasActiveThemeWorld.id, catalogIds);
    };

    self.addToProductView = function($event) {
        self.catalog.canAddToProductView = false;
        self.catalog.canRemoveFromProductView = true;
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        ProductViewService.addVCatsToProductView([self.catalog]);
    };

    self.removeFromProductView = function($event) {
        var catalogIds = [];
        self.catalog.canAddToProductView = true;
        self.catalog.canRemoveFromProductView = false;
        catalogIds.push(self.catalog.id);
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        ProductViewService.removeVCatsFromProductView($context.hasActiveProductView.id, catalogIds);
    };
}